import { LinkButton, Typography } from '@vtblife/uikit';
import React from 'react';
import { Link } from 'react-router-dom';

import Icon from '@vtblife/uikit-icons';

import styles from './upper-navbar-authorized-mobile.module.css';

type UpperNavbarAuthorizedMobileProps = {
    title?: string;
    description?: string;
};

export const UpperNavbarAuthorizedMobile = ({
    title = 'Профиль',
    description = '',
}: UpperNavbarAuthorizedMobileProps) => {
    return (
        <div className={styles.container}>
            <Link to="/account">
                <div className={styles.content}>
                    <div className={styles.info}>
                        <Typography variant="h2" color="white-500" responsive className={styles.title}>
                            {title}
                        </Typography>
                        <Typography variant="small-alone" color="white-500">
                            {description.toLowerCase()}
                        </Typography>
                    </div>
                    <Icon name="chevron-right" color="white" />
                </div>
            </Link>
            <LinkButton size="xs" variant="secondary-alt-bg" href="/">
                На сайт
            </LinkButton>
        </div>
    );
};
